import { render, staticRenderFns } from "./ComplaintDetail.vue?vue&type=template&id=5cfe0b62&scoped=true&"
import script from "./ComplaintDetail.vue?vue&type=script&lang=js&"
export * from "./ComplaintDetail.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintDetail.vue?vue&type=style&index=0&id=5cfe0b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe0b62",
  null
  
)

export default component.exports